module.exports = __webpack_public_path__ + "img/schema_selle_2a.6be95cd5.svg";